import FallbackImageOptions from "%/dynamic-component-editor/bundles/fallback-image-options";
import LinkAction from "%/dynamic-component-editor/options/link-action";
import {
  FallbackImageElementMixin,
} from "%/dynamic-component-editor/standard-elements/image-element/fallback-image-element-mixin";
import LayoutWidthHeightOptions from "%/dynamic-component-editor/bundles/layout-width-height-options";
import SpacingOptions from "%/dynamic-component-editor/bundles/spacing-options";
import { IMAGE_STYLE_OPTION_BUNDLES } from "%/dynamic-component-editor/standard-elements/image-element/standard-image-element-mixin";

export const CustomLinkImageElementMixin = {
  mixins: [FallbackImageElementMixin],
  optionBundles: [
    FallbackImageOptions,
    new LayoutWidthHeightOptions({
      "default.layout-width": 300,
    }),
    SpacingOptions,
    ...IMAGE_STYLE_OPTION_BUNDLES,
  ],
  options: [
    new LinkAction(undefined, true),
  ],
};
